import { render, staticRenderFns } from "./ProductComponent.vue?vue&type=template&id=2e2ebe12&scoped=true"
import script from "./ProductComponent.vue?vue&type=script&lang=js"
export * from "./ProductComponent.vue?vue&type=script&lang=js"
import style0 from "./ProductComponent.vue?vue&type=style&index=0&id=2e2ebe12&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e2ebe12",
  null
  
)

export default component.exports